import { HiOutlineDocumentReport } from 'react-icons/hi';
import { RiDashboardLine } from 'react-icons/ri';
import { MdOutlinePayment, MdOutlineTrackChanges } from 'react-icons/md';
import { FaFileInvoice } from 'react-icons/fa';
import { ImLocation2 } from 'react-icons/im';
import { IoLogOutOutline } from 'react-icons/io5';
// import { IoMdPeople } from 'react-icons/io';
import { RiTruckLine } from 'react-icons/ri';
import { Account_Statment, Booking_Detail1, Booking_Detail2, Dashboard, Invoice_Detail, PickUp_Request, PickUp_Status, Tracking, Stock_Incoming } from 'mmbclient/Common/CommonVariable';

export const SidebarData = [
  {
    title: Dashboard,
    pageName : "Dashboard",
    path: '/dashboard',
    icon: <RiDashboardLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-speedometer",
    component: null,
  },
  // {
  //   title: 'Booking',
  //   path: '/booking',
  //   icon: <HiOutlineDatabase />,
  //   cName: 'nav-text',
  //   visible: true,
  //   iconClass: "bi bi-file-bar-graph",
  //   component: null,
  // },
  // {
  //   title: 'Online Booking Search',
  //   path: '/online-booking-search',
  //   icon: <HiOutlineDocumentReport />,
  //   cName: 'nav-text',
  //   visible: true
  // },
  {
    title: Booking_Detail1,
    pageName : "Booking Detail",
    path: '/consignment-detail',
    icon: <HiOutlineDocumentReport />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-search",
    component: null,
  },
  {
    title: Booking_Detail2,
    pageName : "Booking Detail",
    path: '/consignment-detail',
    icon: <HiOutlineDocumentReport />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-search",
    component: null,
  },
  {
    title: Invoice_Detail,
    pageName : "Invoice Detail",
    path: '/invoice-detail',
    icon: <FaFileInvoice />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-receipt",
    component: null,
  },
  {
    title: Account_Statment,
    pageName : "Account Statment",
    path: '/account-statement',
    icon: <MdOutlinePayment />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-credit-card-2-front",
    component: null,
  },
  {
    title: Tracking,
    pageName : "Tracking",
    path: '/tracking',
    icon: <MdOutlineTrackChanges />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-bullseye",
    component: null,
  },
  {
    title: PickUp_Request,
    pageName : "PickUp Request",
    path: '/credit-pickup-request',
    icon: <RiTruckLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-arrow-down-up",
    component: null,
  },
  {
    title: PickUp_Status,
    pageName : "PickUp Status",
    path: '/credit-pickup-status',
    icon: <RiTruckLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-file-arrow-down",
    component: null,
    subNav : [
                {
                  title: Stock_Incoming,
                  pageName:"Stock Incoming",
                  path:"stock-incoming",
                  cName: "nav_text",
                  visible: true,
                  component: null,
                }
              ]
  },
];

export const TrackingIcon = [
  {
    title: Tracking,
    pageName : "Tracking",
    path: '＃',
    // path: '/mmbclient/tracking',
    icon: <ImLocation2 />,
    cName: 'nav-text'
  }
];


export const LogOut = [
  {
    title: 'Log Out',
    // logOut: 'function() { store.setLogin("out"); }',
    icon: <IoLogOutOutline />,
    cName: 'nav-text'
  }
];
